import React from "react";
export const Note = {
    note_1: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <path d="M30.1,41c-5,0-9.1,2.3-9.1,5.3s4.1,5.3,9.1,5.3,9.2-2.3,9.2-5.3S35.1,41,30.1,41Zm-2.5,8.6a6.9,6.9,0,0,1-2.4-4.4c-.3-3.4,3-3.6,5.3-3.2s4,2.9,4.5,5.9S29.8,51.5,27.6,49.6Z" />
        </svg>
    ),
    note_2: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <g>
                <line x1="35" y1="8" x2="35" y2="45" style={{ fill: "none", strokeMiterlimit: 10, strokeWidth: 2 }} />
                <path d="M35.2,43.2c-1.2-2.9-5.7-3.7-10-1.8s-6.7,5.8-5.3,8.8,5.7,3.6,10,1.8S36.6,46.1,35.2,43.2Zm-1.3,2.2a19.7,19.7,0,0,1-5.3,4.2c-3.1,1.9-6.6,2.6-7.9.7,0,0-.7-1.2.7-3.1s7.9-5.1,9.7-5.3,2.5,0,3.2.9A2.7,2.7,0,0,1,33.9,45.4Z" />
            </g>
        </svg>
    ),
    note_4: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <g transform="translate(6 0)">
                <line x1="30" y1="8" x2="30" y2="45" style={{ fill: "none", strokeMiterlimit: 10, strokeWidth: 2 }} />
                <path d="M30.3,43.5c-1.6-2.8-6.3-3.3-10.5-1s-6.3,6.2-4.8,9,6.3,3.2,10.4.9S31.8,46.2,30.3,43.5Z" />
            </g>
        </svg>
    ),
    note_8: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <g transform="translate(6 0)">
                <line x1="30" y1="8" x2="30" y2="45" style={{ fill: "none", strokeMiterlimit: 10, strokeWidth: 2 }} />
                <path d="M30.3,43.5c-1.6-2.8-6.3-3.3-10.5-1s-6.3,6.2-4.8,9,6.3,3.2,10.4.9S31.8,46.2,30.3,43.5Z" />
                <path d="M30,9h1.1s.2,2.6,4.5,9.3,11.5,10.3,5.3,23c0,0-.3.7-.9.7s-.4-.2-.1-.8,6.9-14.9-8.7-19.7H30Z" />
            </g>
        </svg>
    ),
    note_16: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <g transform="translate(6 0)">
                <line x1="30" y1="8" x2="30" y2="45" style={{ fill: "none", strokeMiterlimit: 10, strokeWidth: 2 }} />
                <path d="M30,9h1s1.5,6.1,9.3,13.2S42,34.7,42,34.7V31.4s1.9-6.2-9.9-11.3a45.4,45.4,0,0,0,4.8,6.7c1.8,1.8,4.9,3.1,6.3,7.2a8.7,8.7,0,0,1-1.5,7.8c-.6.6-1.1,0-.8-.8s1.7-4.6.3-6.4a28,28,0,0,0-9-6.6H30Z" />
                <path d="M30.3,43.5c-1.6-2.8-6.3-3.3-10.5-1s-6.3,6.2-4.8,9,6.3,3.2,10.4.9S31.8,46.2,30.3,43.5Z" />
            </g>
        </svg>
    ),
};

export const Stick = {
    note_1: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <path d="M30.1,41c-5,0-9.1,2.3-9.1,5.3s4.1,5.3,9.1,5.3,9.2-2.3,9.2-5.3S35.1,41,30.1,41Zm-2.5,8.6a6.9,6.9,0,0,1-2.4-4.4c-.3-3.4,3-3.6,5.3-3.2s4,2.9,4.5,5.9S29.8,51.5,27.6,49.6Z" />
        </svg>
    ),
    note_2: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <g>
                <line x1="35" y1="15" x2="35" y2="45" style={{ fill: "none", strokeMiterlimit: 10, strokeWidth: 2 }} />
                <path d="M35.2,43.2c-1.2-2.9-5.7-3.7-10-1.8s-6.7,5.8-5.3,8.8,5.7,3.6,10,1.8S36.6,46.1,35.2,43.2Zm-1.3,2.2a19.7,19.7,0,0,1-5.3,4.2c-3.1,1.9-6.6,2.6-7.9.7,0,0-.7-1.2.7-3.1s7.9-5.1,9.7-5.3,2.5,0,3.2.9A2.7,2.7,0,0,1,33.9,45.4Z" />
            </g>
        </svg>
    ),
    note_4: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <line x1="30" y1="15" x2="30" y2="45" style={{ fill: "none", strokeMiterlimit: 10, strokeWidth: 2 }} />
        </svg>
    ),
    note_8: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <line x1="30" y1="15" x2="30" y2="45" style={{ fill: "none", strokeMiterlimit: 10, strokeWidth: 2 }} />
            <path d="M30,15h.8s.2,1.5,3,5.3,7.7,5.9,3.5,13.1a.7.7,0,0,1-.6.4s-.2-.1-.1-.5,4.7-8.5-5.8-11.2H30Z" />
        </svg>
    ),
    note_16: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <line x1="30" y1="15" x2="30" y2="45" style={{ fill: "none", strokeMiterlimit: 10, strokeWidth: 2 }} />
            <path d="M30,15h.7s1,4.1,6.2,8.8S38,32.2,38,32.2V30s1.3-4.2-6.6-7.6a28.3,28.3,0,0,0,3.2,4.5c1.2,1.2,3.3,2.1,4.2,4.8a5.7,5.7,0,0,1-1,5.2c-.4.4-.7,0-.5-.5s1.1-3.1.2-4.3a20.2,20.2,0,0,0-6-4.4H30Z" />
        </svg>
    ),
};

const note_1 = () => (
    <svg width="60" height="60" viewBox="0 0 60 60">
        <g>
            <line x1="19.5" y1="30.7" x2="40.5" y2="30.7" style={{ fill: "none", strokeMiterlimit: 10 }} />
            <rect x="25" y="30.3" width="10.5" height="4.75" />
        </g>
    </svg>
);

const note_2 = () => (
    <svg width="60" height="60" viewBox="0 0 60 60">
        <g>
            <line x1="19.5" y1="34.7" x2="40.5" y2="34.7" style={{ fill: "none", strokeMiterlimit: 10 }} />
            <rect x="25" y="30" width="10.5" height="5.25" />
        </g>
    </svg>
);

const note_4 = () => (
    <svg width="60" height="60" viewBox="0 0 60 60">
        <path d="M31,47.9c-7-6.5-.2-10.7,5.2-7.8-7.4-9.6-7.3-8.1-1.4-16.8L26.5,11.8a.8.8,0,0,0-.8.6c4.1,5.7,5.6,7.7-1.6,14.7,0,0,6.1,6.6,7.3,8.9,0,0-8-3.4-7.6,5.2.5,3.7,4.2,6.2,6.8,7C30.9,48.3,31.2,48,31,47.9Z" />
    </svg>
);

const note_8 = () => (
    <svg width="60" height="60" viewBox="0 0 60 60">
        <path d="M28.1,44.1h0l3.5-8.8,5.7-14.1c-5.7,4.6-8.5,3.4-8.5,3.4,1.3-2,1.3-4.6-.4-5.3a5.1,5.1,0,0,0-4.5.6,2.9,2.9,0,0,0-.6,4.1h0c1.3,1.8,3.2,1.8,5,1.9s6.8-1.4,6.8-1.4L29.3,37.1l-.8,1.7h0l-2.3,5.3" />
    </svg>
);

const note_16 = () => (
    <svg width="60" height="60" viewBox="0 0 60 60">
        <path d="M38.6,21.2c-5.7,4.6-8.5,3.4-8.5,3.4,1.3-2,1.3-4.6-.4-5.3a5.1,5.1,0,0,0-4.5.6,2.9,2.9,0,0,0-.6,4.1h0c1.3,1.8,3.2,1.8,5,1.9s6.7-1.4,6.7-1.4L31.5,35.3c-3.7,2.4-4.2.8-4.2.8,1.2-2,1.2-4.6-.4-5.3a5.3,5.3,0,0,0-4.6.6,2.9,2.9,0,0,0-.6,4.1h0c1.3,1.8,3.2,1.8,5,1.9a30.3,30.3,0,0,0,4.2-.6l-1,2.1h0l-2.4,5.2h1.9l3.5-8.7Z" />
    </svg>
);

export const Rest = {
    note_1,
    note_2,
    note_4,
    note_8,
    note_16,
};

export const RestStick = {
    note_1,
    note_2,
    note_4: () => (
        <svg width="60" height="60" viewBox="0 0 60 60">
            <path d="M37.1,41.2a3.4,3.4,0,0,1-3.4,2.4,3.1,3.1,0,0,1-2.9-3.3c.1-.3.1-.5.2-.8s-1.8-.7-7,3.5h-.7L34.4,24.1a28.3,28.3,0,0,1-5.8,1.1c-1.8,0-3.8-.1-5-1.8a2.9,2.9,0,0,1,.6-4.1h0a5.1,5.1,0,0,1,4.5-.6c1.7.7,1.7,3.3.4,5.3,0,0,2.8,1.2,8.5-3.4L26.2,40.2c.2-.1,3-1.4,4.8-2s3.1-1.5,4.8-.6A2.8,2.8,0,0,1,37.1,41.2Z" />
        </svg>
    ),
    note_8,
    note_16,
};
